/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const QuoteWorkUnit = {
    Daily: 'DAILY',
    Hourly: 'HOURLY'
} as const;
export type QuoteWorkUnit = typeof QuoteWorkUnit[keyof typeof QuoteWorkUnit];


export function instanceOfQuoteWorkUnit(value: any): boolean {
    for (const key in QuoteWorkUnit) {
        if (Object.prototype.hasOwnProperty.call(QuoteWorkUnit, key)) {
            // @ts-ignore
            if (QuoteWorkUnit[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function QuoteWorkUnitFromJSON(json: any): QuoteWorkUnit {
    return QuoteWorkUnitFromJSONTyped(json, false);
}

export function QuoteWorkUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteWorkUnit {
    return json as QuoteWorkUnit;
}

export function QuoteWorkUnitToJSON(value?: QuoteWorkUnit | null): any {
    return value as any;
}

